import React from "react";

import type { Job } from "./jobTypes";

const JobList = React.lazy(() => import("./JobList"));
const JobShow = React.lazy(() => import("./JobShow"));
const JobEdit = React.lazy(() => import("./JobEdit"));
const JobCreate = React.lazy(() => import("./JobCreate"));

export default {
  list: JobList,
  show: JobShow,
  edit: JobEdit,
  create: JobCreate,
  recordRepresentation: (record: Job) =>
    [record.code, record.customer_name].filter(Boolean).join(" · "),
};
